import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import { getTagPage } from "../configureStore";
import { fetchTagPage } from "../configureStore/tagPage";
import { getHelmet } from "../utilities";
import { FromTopPage, Banner, GridWrapper } from "../theme";
import NotFound from "../components/NotFound";
import Error from "../components/Error";
import PageLoader from "../components/loader/PageLoader";
import StoryList from "../components/story/StoryList";
import Pagination from "../components/Pagination";
import JoinUs from "../components/JoinUs";

const Container = styled(FromTopPage)`
  header {
    margin-bottom: 60px;

    @media (max-width: 767px) {
      margin-bottom: 30px;
    }
  }
`;

class Category extends Component {
  static fetchInitialData({ slug, page }) {
    return [fetchTagPage(slug, page)];
  }

  componentDidMount() {
    this.fetchContent();
  }

  componentDidUpdate() {
    this.fetchContent();
  }

  fetchContent() {
    const { tagPage, dispatch, match } = this.props;

    if (!tagPage.isFetching && !tagPage.error && !tagPage.content.length) {
      dispatch(fetchTagPage(match.params.slug, match.params.page));
    }
  }

  render() {
    const tagPage = this.props.tagPage;

    if (!tagPage.nbrPages && tagPage.error) {
      if (tagPage.error === "404") {
        return <NotFound />;
      }

      return <Error message={tagPage.error} />;
    }

    if (!tagPage.nbrPages) {
      return <PageLoader />;
    }

    return (
      <Container>
        <Helmet>
          {getHelmet(
            tagPage.tag.label,
            tagPage.tag.description,
            this.props.location.pathname
          )}
        </Helmet>
        <Banner>
          <GridWrapper>
            <div>
              <h1>{tagPage.tag.label}</h1>
              <p>{tagPage.tag.description}</p>
            </div>
          </GridWrapper>
        </Banner>
        <Pagination nbrPages={tagPage.nbrPages} />
        <StoryList storyList={{ ...tagPage, stories: tagPage.content }} />
        <Pagination nbrPages={tagPage.nbrPages} />
        <JoinUs />
      </Container>
    );
  }
}

Category.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      page: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  tagPage: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.string,
    tag: PropTypes.shape({
      label: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
    nbrPages: PropTypes.number,
    content: PropTypes.array.isRequired,
  }).isRequired,
};

export default connect((state, ownProps) => ({
  tagPage: getTagPage(
    state,
    ownProps.match.params.slug,
    ownProps.match.params.page
  ),
}))(Category);
